import React, { Component } from 'react';
import styled from 'styled-components';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import CheckboxGroup from './checkboxGroup';
import { connect } from 'react-redux';
import dataService from 'api/dataService';
import { Text } from 'components/styled/ui';
import { media } from 'components/styled/utils';
import $ from 'jquery';
import { images, strings } from 'config';

class CheckboxTree extends Component {
  state = {};

  componentDidMount() {
    this.slideToggleContent();
    dataService.getCategories().then(response => {
      this.filterDataForTree(response.categories);
    });
  }

  slideToggleContent() {
    let self = this;
    $(ReactDOM.findDOMNode(this.refs.categoriesGroup))
      .find('.header')
      .click(function() {
        $(ReactDOM.findDOMNode(self.refs.categoriesGroup)).toggleClass('expanded');
      });
  }

  componentWillReceiveProps(nextProps) {
    const { filters } = nextProps;
    this.setState(filters.categories);
  }

  filterDataForTree(categories) {
    const categoriesData = _.transform(
      categories,
      (acc, children, groupName) => {
        const categoryTitle = categories[groupName].title;
        const categoryTitleNp = categories[groupName].title_ne;
        acc[categoryTitle] = {
          title: categoryTitle,
          titleNp: categoryTitleNp,
          checked: false,
          category_id: children.category_id,
          count: children.count,
          children: _.transform(
            children.subcategories,
            (acc, child) =>
              (acc[child.title] = {
                id: child.category_id,
                title: child.title,
                titleNp: child.title_ne,
                checked: false,
                count: child.count
              }),
            {}
          )
        };
      },
      {}
    );

    this.setState(categoriesData);
  }

  onGroupChange = groupName => {
    const { onCategoriesChange } = this.props;

    let newState = this.state;
    let group = newState[groupName];
    group.checked = !group.checked;
    _.forEach(group.children, c => {
      c.checked = group.checked;
    });

    this.setState(newState);
    onCategoriesChange(newState);
  };

  onChildChange = (groupName, childName) => {
    const { onCategoriesChange } = this.props;

    let newState = this.state;
    var group = newState[groupName];
    group.children[childName].checked = !group.children[childName].checked;
    group.checked = _.every(group.children, 'checked');

    this.setState(newState);
    onCategoriesChange(newState);
  };

  render() {

    const { dataList } = this.props;

    return (
      <Panel ref="categoriesGroup">
        <Header className="header">
          <Text.span size={14}>{strings.filters.categories}</Text.span>
          <img className="icon" src={images.icons.downArrow} alt="" />
        </Header>

        <Body className="categories-filter">
          {_.map(this.state, item => (
            <CheckboxGroup
              dataList={dataList}
              key={item.title}
              onGroupChange={this.onGroupChange}
              onItemChange={this.onChildChange}
              {...item}
            />
          ))}
        </Body>
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    // dataList: state.datahub.dataList
  };
};

export default connect(mapStateToProps)(CheckboxTree);

const Panel = styled.div`
  border-bottom: 1px solid #ebebeb;
  

  .icon {
    transform: rotate(180deg);
  }

  .icon {
    transition: transform 0.1s ease-in;
  }

  .categories-filter{
    display: none;
  }

  &.expanded {
    .categories-filter {
      display: block;
    }
    .icon {
      transform: rotate(360deg);
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px;
  cursor: pointer;
  > span {
    color: #016bc2;
    &:first-child {
      font-weight: 600;
    }
    &:last-child {
      font-size: 20px;
    }
  }
`;

const Body = styled.div``;

export const Footer = styled.div`
  background: ${props => props.theme.neutrals.shukrabaar};
  border-radius: 0 0 4px 4px;
  padding: 30px 16px;

  ${media.sm`
    display: flex;
    justify-content: center;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/layouts/checkboxTree/checkboxTree.js